<template>
    <div class="fullWidth">
        <kgr-generic-select
            v-model="selection"
            :options="options"
            display="name"
            @post-input="updateLanguageLevel()"
        />
    </div>
</template>

<script>
import GenericSelect from './GenericSelect.vue';

export default {
    components: {
        'kgr-generic-select': GenericSelect,
    },
    props: {
        value: {
            type: String,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            options: [
                { value: 'level.A1', name: this.$t('language.level.A1') },
                { value: 'level.A2', name: this.$t('language.level.A2') },
                { value: 'level.B1', name: this.$t('language.level.B1') },
                { value: 'level.B2', name: this.$t('language.level.B2') },
                { value: 'level.C1', name: this.$t('language.level.C1') },
                { value: 'level.C2', name: this.$t('language.level.C2') },
                { value: 'level.motherlanguage', name: this.$t('language.level.motherlanguage') },
            ],
            selectionValue: null,
        };
    },
    computed: {
        selection: {
            get() {
                if (this.value === null && this.selectionValue === null) {
                    return null;
                } else {
                    if (this.selectionValue === null) {
                        return this.options.find((element) => element.value === this.value);
                    } else {
                        return this.options.find((element) => element.value === this.selectionValue);
                    }
                }
            },
            set(object) {
                this.selectionValue = object !== null ? object.value : null;
            },
        },
    },
    methods: {
        updateLanguageLevel() {
            this.$emit('input', this.selectionValue);
            this.$nextTick(() => {
                this.$emit('post-input', this.selectionValue);
            });
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .fullWidth {
    width: 100%;
}
</style>
